import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-item-slider',
  templateUrl: './item-slider.component.html',
  styleUrls: ['./item-slider.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ItemSliderComponent implements OnInit {

  @Input() 
    items = [];
  @Output()
    onItemSelected = new EventEmitter<any>();
  @ViewChild('scrollContent') scrollContent;

  constructor() { }

  ngOnInit() {
  }

  toggleItem(_index, _item) {
    this.onItemSelected.emit({item: _item, index: _index});
  }

  scroll(e) {
    if (e === 'r') {
      this.scrollContent.nativeElement.scrollLeft += 50
      if (this.scrollContent.nativeElement.scrollLeft > (this.scrollContent.nativeElement.scrollWidth - this.scrollContent.nativeElement.offsetWidth)) {
        this.scrollContent.nativeElement.scrollLeft = this.scrollContent.nativeElement.scrollWidth - this.scrollContent.nativeElement.offsetWidth;
      }
    } else {
      this.scrollContent.nativeElement.scrollLeft -= 50;
      if (this.scrollContent.nativeElement.scrollLeft < 0) {
        this.scrollContent.nativeElement.scrollLeft = 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/item-slider/item-slider.component.ts